/* Material grid deep links.

   A panel links to #finish-studio and carries data-sfs-material; Finish Studio
   filters itself to that material on the way past. The link stays an ordinary
   anchor, so the browser still does the scrolling and this only sets the filter
   first — with JS off, or with Finish Studio not on the page, the link degrades
   to a plain jump rather than breaking.

   The two sections talk through the filter control and a change event rather
   than through each other's internals, so neither has to know how the other
   works and either can be removed without taking the other down. */
(function () {
  'use strict';

  /* An option can stand for several materials, its value being those materials
     joined by a pipe — Clear and Frosted are one entry. So a panel asking for
     "Clear" has to settle for the option that CONTAINS Clear when no option is
     exactly Clear. Asking by member rather than by exact value also means the
     grid does not have to know how Finish Studio groups things today: regroup
     them there and these links keep working. */
  function apply(name) {
    var sel = document.querySelector('[data-sfs-filter]');
    if (!name || !sel) return;

    var member = null;
    for (var i = 0; i < sel.options.length; i++) {
      var v = sel.options[i].value;
      if (v === name) { member = v; break; }
      if (!member && v && ('|' + v + '|').indexOf('|' + name + '|') !== -1) member = v;
    }
    if (member === null) return;

    sel.value = member;
    sel.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* Capture phase, so the filter is set before the browser jumps rather than
     after it — otherwise the section re-renders under the shopper mid-scroll. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var a = t && t.closest ? t.closest('[data-sfs-material]') : null;
    if (a) apply(a.getAttribute('data-sfs-material'));
  }, true);

  /* The same for a pasted or shared link: /?material=Silicone#finish-studio.
     Deferred a tick so Finish Studio has built its options and attached its own
     change listener first, whichever order the two scripts happen to load in. */
  setTimeout(function () {
    try {
      var q = new URLSearchParams(window.location.search).get('material');
      if (q) apply(q);
    } catch (err) {}
  }, 0);
})();
